/****
 * This component just queries to see if there are any partner programs at all.  This is so a 'coming soon' can be displayed.
 * The inner components of the container then are shown if the count is not 0.
 */
import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import withStyles from '@mui/styles/withStyles';
import { Grid, Typography } from '@mui/material';

import LoadingSpinner from '../ui/LoadingSpinner';
import ServerError from '../ui/ServerError';

import PartnerPrograms from '../vendor/PartnerPrograms';
import PartnerProgramsDiscovery from '../vendor/PartnerProgramsDiscovery';

const abEnvironment = new AbEnvironment();
const PartnerProgramsContainerQuery = graphql`
query PartnerProgramsContainerQuery($accountId: UUID!) {
  allVppTs (condition: {visibility: 2}) {
    totalCount
  },
  accountTByAccountId(accountId: $accountId) {
    vppRTsByPartnerId {
      totalCount
    }
  }
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
    //marginTop: 10,
  },
  flex: {
    flex: 1,
  },
  paper: {
    maxWidth: 1200,
    marginTop: '16px'
  },
  tblHead: {
    backgroundColor: '#f1f1f1',
  },
  tblHeadRow: {
    height: 32,
  }
});

class PartnerProgramsContainer extends Component {

  constructor(props) {
    super(props);

    this.state = {
      
    };  
  }

  
  render() {
    const { isAuthenticated, isAuthenticatedReseller, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    if (!isAuthenticated() || needAssent()) {
      return (
        <Redirect to='/home' />
      );
    }

    if (isAuthenticatedReseller())
    {
      let accountId = abEnvironment.getUserAttribute('a_id');

      return (
        <div className={classes.root}>
          <QueryRenderer
            environment={abEnvironment.getEnvironment()}
            query={PartnerProgramsContainerQuery}
            variables={{accountId: accountId}}
            render={({error, props})=> {
              if (error) {
                logError(error.message);
                return (
                  <ServerError/>
                );
              } else if (props) {
                if ((props.allVppTs.totalCount > 0) || (props.accountTByAccountId.vppRTsByPartnerId.totalCount > 0)) {
                  return (
                    <React.Fragment>
                      <PartnerPrograms
                        auth={this.props.auth}
                        history={this.props.history}
                      />
                      <div style={{marginTop: '36px'}}>
                        <PartnerProgramsDiscovery
                          auth={this.props.auth}
                          history={this.props.history}
                        />
                      </div>
                    </React.Fragment>                  
                  );
                } else {
                  return (
                    <Grid container spacing={2} direction="row" justifyContent="flex-start">
                      <Grid item xs={12}>
                        <Typography>Coming soon.</Typography>
                      </Grid>
                    </Grid>
                  );
                }
              }
              return (
                <div>
                  <Typography>Loading...</Typography>
                  <LoadingSpinner/>
                </div>
              );
            }}
          />
        </div>
      );
    }
    else
    {
      return (
        <Redirect to='/home' />
      );
    }
  }

}

export default withStyles(styleSheet)(PartnerProgramsContainer);
